<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="0" >四，這個黑色格子，難道是『阿四』⋯⋯？</npc>
              <npc :npc-id="1" right>阿四？阿四是什麼？</npc>
              <npc :npc-id="0" >是賴和先生的一篇小說，據說有自傳性質；等等，這邊寫著『文化演講』——我知道了，怪盜是要我們到『元清觀』！</npc>
              <npc :npc-id="1" right>元清觀？為什麼？</npc>
              <npc :npc-id="0" >元清觀過去被稱為『天公壇』，在日本時代，前面的廟埕堪稱文人講堂；〈阿四〉的主角曾在像元清觀這樣的地方發表文化演講，因此文化演講就是在暗示元清觀！</npc>
              <npc :npc-id="1" right>啊，原來如此，果然是跟賴和有關的地點呢！</npc>
              <npc :npc-id="0" >而且不止〈阿四〉，1927年的『國際勞動紀念日』，賴和先生也曾在元清觀發表作品。</npc>
              <npc :npc-id="1" right>咦？好意外，將近一百多年前的臺灣就會過什麼『國際勞動紀念日』了？</npc>
              <npc :npc-id="0" >是啊，其實那時的臺灣是很摩登、很國際化的喔？這樣的風氣是到戰爭時期才逐漸封閉的。</npc>
              <npc :npc-id="1" right>很能理解呢，畢竟都世界大戰了，知識也不可能自由流通了吧？有通敵嫌疑。</npc>
              <npc :npc-id="0" >是啊，但解開這一題，我對怪盜的所做所為更加不解了。</npc>
              <npc :npc-id="1" right>怎麼說？</npc>
              <npc :npc-id="0" >為何怪盜引導我來孔廟呢？他到底要證明什麼？像這樣解謎，甚至沒偷走新的東西到底有何意義？</npc>
              <npc :npc-id="1" right>該不會他早就偷了，只是我們沒發現？</npc>
              <npc :npc-id="0" >一點提示都沒有，作為怪盜根本不及格吧！</npc>
              <npc :npc-id="1" right>或許他根本不是怪盜，只是我們先入為主啊？</npc>
              <npc :npc-id="0" >也有可能。但無論如何，我們只能追下去，畢竟非得救回擁有臺灣文學館的歷史不可。</npc>
              <npc :npc-id="1" right>沒錯，往元清觀吧！</npc>
              <npc :npc-id="0" >對，走！</npc>

              <map-link name="元清觀" map-id="sCJw7r225nLBNEJs8"/>

              <move-to-stage-btn link="前往元清觀">前往元清觀</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage4_1',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第四章 - 1',
      isQuestion: false,
      stageId: 'four',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
